var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{staticClass:"search__box",attrs:{"id":"searchbox","url":"/api/v1/search","anchor":"title","placeholder":"Search for model","min":3,"on-select":_vm.itemSelected,"process":_vm.processJsonData}})
}
var staticRenderFns = []

export { render, staticRenderFns }